
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'
import { connect } from 'react-redux'
import getProp from '@f/get-prop'
import { getWarehouseMetadataById } from 'selectors'
import ConnectingLoader from 'ui/ConnectingLoader'
import Space from 'ui/Space'

const WarehouseSetupConnectingContainer = props => (
  <div className={css.main}>
    <ConnectingLoader logo={props.logo} name={props.name} isConnecting />
    <Space value='40' />
    Trying to connect. Please wait.
  </div>
)

function mapStateToProps (state) {
  const {
    databaseId,
    isConnecting
  } = state.application.warehouseSetup

  const database = getWarehouseMetadataById(state, databaseId)
  const logo = getProp('logos.default', database)
  const name = getProp('name', database)

  return { logo, name, isConnecting }
}

WarehouseSetupConnectingContainer.propTypes = {
  logo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

WarehouseSetupConnectingContainer.displayName = 'WarehouseSetupConnectingContainer'

export default connect(mapStateToProps)(WarehouseSetupConnectingContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-connecting/index.js